import { Modal } from '@arco-design/web-react';
import { IconCloseCircle } from '@arco-design/web-react/icon';
import EmojiPicker, { EmojiClickData } from 'emoji-picker-react';

import './EmojiPickerModal.css';

export const EmojiPickerModal = ({
  visible,
  onClose,
  onEmojiClick
}: {
  visible: boolean;
  onClose: () => void;
  onEmojiClick: (emojiData: EmojiClickData) => void;
}) => (
  <Modal
    simple
    escToExit
    focusLock
    visible={visible}
    footer={null}
    style={{ padding: 0, maxWidth: 310 }}
    onCancel={onClose}
  >
    <div className="emoji-modal__wrapper">
      <div className="emoji-modal__header">
        <IconCloseCircle
          className="emoji-modal__header-icon"
          onClick={onClose}
        />
      </div>
      <EmojiPicker
        width={300}
        height={400}
        previewConfig={{ showPreview: false }}
        onEmojiClick={onEmojiClick}
      />
    </div>
  </Modal>
);